import { FreeCourseSection } from '~/features/ai-marketer/components/free-course-section';
import { AiMarketerHeroSection } from '~/features/ai-marketer/components/hero-section';
import { StartLearningSection } from '~/features/ai-marketer/components/start-learning-section';
import { AiMarketerStatsSection } from '~/features/ai-marketer/components/stats-section';
import { StayPostedSection } from '~/features/ai-marketer/components/stay-posted-section';
import { AiMarketerTestimonialsSection } from '~/features/ai-marketer/components/testimonials-section';
import { AiMarketerVideoSection } from '~/features/ai-marketer/components/video-section';
import { WhyUdacitySection } from '~/features/ai-marketer/components/why-udacity-section';
import { AiMarketerPageProps } from '~/features/ai-marketer/types';

export function AiMarketerPage({ startLearningPrograms }: Omit<AiMarketerPageProps, 'page'>) {
  return (
    <>
      <AiMarketerHeroSection />
      <AiMarketerVideoSection />
      <FreeCourseSection />
      <AiMarketerTestimonialsSection />
      <AiMarketerStatsSection />
      <WhyUdacitySection />
      <StartLearningSection programs={startLearningPrograms} />
      <StayPostedSection />
    </>
  );
}
